import React, { useEffect, useState } from 'react';
import { useUserAuth } from '../context/UserAuthContext';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailPromptModal = () => {
  const { user, isAuthenticated, setEmail } = useUserAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmailValue] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user && !user.email) {
      setIsOpen(true);
    }
  }, [isAuthenticated, user?.email, user?.username]);

  if (!isAuthenticated || !user || !isOpen || user.email) {
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const trimmed = email.trim();
    if (!EMAIL_REGEX.test(trimmed)) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    const result = await setEmail(trimmed);
    setIsSubmitting(false);

    if (result.success) {
      setIsOpen(false);
      setEmailValue('');
    } else {
      setError(result.error || 'Failed to save email.');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-6">
      <div className="w-full max-w-md bg-[#0a0a0a] border border-white/10 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-white text-lg font-medium">Add your email</h2>
          <button
            type="button"
            className="text-white/50 hover:text-white transition-colors"
            onClick={() => setIsOpen(false)}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <p className="text-white/60 text-sm mb-4">
          Please add your email to continue. You can close this box, but it will appear again until you submit an email.
        </p>
        {error && (
          <div className="mb-4 p-3 border border-red-500/30 bg-red-500/10">
            <p className="text-sm text-red-400">{error}</p>
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-white/40 text-xs font-mono tracking-widest mb-2">EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmailValue(e.target.value)}
              className="w-full px-4 py-3 bg-white/[0.02] border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-white/30 transition-colors"
              placeholder="Enter your email"
              required
              disabled={isSubmitting}
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full px-6 py-3 bg-white text-black font-medium hover:bg-white/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Saving...' : 'Save Email'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailPromptModal;
